import apiClient from "./index";

export const findAll = () => {
    return apiClient.post(`/sys/contsType/findByContsAuthrtSys.json`);
}

export const accessCheck = params => {
    return apiClient.post(`/sys/accesCtrl/accessCheck.json`, params);
}